<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <div v-show="!showadd && !showdetail && !showbox && !showused" class="filter-container">
        <el-card shadow="never" class="custom-card">
          <el-input
            :placeholder="$t('table.imei')"
            v-model="listQuery.identitys"
            style="width: 200px;"
            class="filter-item"
            @keyup.enter.native="handleFilter"
          />
          <el-input
            :placeholder="$t('table.address')"
            v-model="listQuery.addresss"
            style="width: 200px;"
            class="filter-item"
            @keyup.enter.native="handleFilter"
          />

          <el-select
            v-model="listQuery.state"
            :placeholder="`状态`"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in states"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <!-- <el-select
          v-model="listQuery.binDingAgents"
          :placeholder="$t('table.size')"
          clearable
          style="width: 150px"
          class="filter-item"
        >
          <el-option
            v-for="item in binDingAgentss"
            :key="item.key"
            :label="item.display_name"
            :value="item.key"
          />
        </el-select>
        <el-select
          v-model="listQuery.binDingFields"
          :placeholder="$t('table.field')"
          clearable
          class="filter-item"
          style="width: 130px"
        >
          <el-option
            v-for="item in binDingFieldss"
            :key="item.key"
            :label="item.display_name"
            :value="item.key"
          />
        </el-select> -->
          <el-button
            v-waves
            round
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="search"
          >{{ $t('table.search') }}</el-button>
          <el-button
            v-if="calcPermission(permition, 1)"
            round
            class="filter-item"
            style="margin-left: 10px;"
            type="danger"
            icon="el-icon-circle-plus-outline"
            @click="adddevice()"
          >{{ $t('table.add') }}</el-button>
          <el-button
            v-if="calcPermission(permition, 1)"
            round
            class="filter-item"
            type="primary"
            @click="headShowBindDevices"
          >{{ '批量添加箱子' }}</el-button>
          <el-button
            v-if="calcPermission(permition, 1)"
            round
            class="filter-item"
            type="primary"
            @click="handleBatchAddDevice"
          >{{ '批量添加设备' }}</el-button>
          <el-button
            v-if="calcPermission(permition, 4)"
            round
            class="filter-item"
            type="primary"
            @click="bindField"
          >{{ $t('table.bindField') }}</el-button>
          <el-button
            v-if="calcPermission(permition, 5)"
            round
            class="filter-item"
            type="primary"
            @click="bindAgent"
          >{{ $t('table.bindAgent') }}</el-button>
          <el-select
            v-model="bookType"
            :placeholder="$t('table.saveType')"
            clearable
            class="filter-item"
            style="width: 130px"
          >
            <el-option v-for="item in bookTypeList" :key="item" :label="item" :value="item"/>
          </el-select>
          <el-button
            v-waves
            :loading="downloadLoading"
            round
            class="filter-item"
            type="primary"
            icon="el-icon-download"
            @click="handleDownload"
          >{{ $t('table.export') }}</el-button>
          <!-- <el-button
            v-waves
            round
            class="filter-item"
            type="primary"
            @click="opreaGroup"
          >分组</el-button> -->
        </el-card>

      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!showadd && !showdetail && !showbox && !showused" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            :label="$t('table.change')"
            fixed
            prop="Identity"
            type="selection"
            align="center"

          >
            <!-- <template>
              <el-checkbox v-model="checked">备选项</el-checkbox>
            </template>-->
          </el-table-column>
          <el-table-column
            :label="$t('table.imei')"
            prop="Identity"
            fixed="left"
            align="center"

          >
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.Identity">{{ scope.row.LsList.Identity }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('table.deviceName')"
            fixed="left"

            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.Name">{{ scope.row.LsList.Name }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`场地名称`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.FieldName">{{ scope.row.FieldName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`代理商名称`" align="center">
            <template slot-scope="scope">
              <template
                v-if="scope.row.AgentName ||
                  scope.row.AgentName1 ||
                  scope.row.AgentName2 ||
                  scope.row.AgentName3 ||
                  scope.row.AgentName4
                ">
                <el-link :underline="false" type="primary">{{
                  scope.row.AgentName ||
                    scope.row.AgentName1 ||
                    scope.row.AgentName2 ||
                    scope.row.AgentName3 ||
                    scope.row.AgentName4
                }}</el-link>
                <!-- <el-tooltip placement="top">
                  <div slot="content">
                    <p>代理商1：{{ scope.row.AgentName }}</p>
                  </div>

                </el-tooltip> -->
              </template>
              <!-- <span v-if="scope.row.AgentName">{{ scope.row.AgentName }}</span> -->
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.address')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.Address">{{ scope.row.LsList.Address }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- <template v-if="roleId === 1">
            <el-table-column :label="`是否隐藏`" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.LsList.IsOpenHide">已隐藏</span>
                <span v-else>未隐藏</span>
              </template>
            </el-table-column>
            <el-table-column :label="`隐藏比例`" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.LsList.HideProportion">{{ scope.row.LsList.HideProportion }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column :label="`隐藏基数`" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.LsList.StartHideCount">{{ scope.row.LsList.StartHideCount }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
          </template>

          <el-table-column :label="$t('table.memberCount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.Count || 0 }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column :label="$t('table.maxMemberCount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.LsList.MemberCount || 0 }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column :label="$t('table.isDepositTel')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.LsList.IsDepositTel === 'Y' ? '是' : scope.row.LsList.IsDepositTel === 'N' ? '否' : '--' }}</span>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('table.lineStatus')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.LineState === 'On' ? '在线' : scope.row.LineState === 'Off' ? '离线' : '--' }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('table.status')" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.LsList.StatusNo"
              >{{ scope.row.LsList.StatusNo === 'A' ? '管理员添加' : scope.row.LsList.StatusNo === 'S' ? '离线' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column :label="$t('table.cellNum')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.LsList.BoxInfos ? scope.row.LsList.BoxInfos.length : '--' }}</span>
            </template>
          </el-table-column>-->
          <el-table-column :label="$t('table.userCount')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.UseTotalCount">{{ scope.row.LsList.UseTotalCount || 0 }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column v-if="RoleId === 1" :label="$t('table.totalIncome')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.LsList.TotalIncome || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.lastConnTime')" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.LastLinkTime">{{ scope.row.LsList.LastLinkTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('table.actions')"
            fixed="right"
            align="center"
            width="200"
            class-name="small-padding fixed-width"
          >
            <template slot-scope="scope">
              <el-link
                v-if="calcPermission(permition, 1) && scope.row.LsList.StatusNo === 'S'"
                class="custom-link"
                type="success"
                @click="handleEnabled(scope.row)"
              >启用</el-link>
              <el-link
                v-if="calcPermission(permition, 1) && scope.row.LsList.StatusNo === 'A'"
                class="custom-link"
                type="danger"
                @click="handleDis(scope.row)"
              >禁用</el-link>
              <el-link
                v-if="calcPermission(permition, 1)"
                class="custom-link"
                type="primary"
                @click="adddevice(scope.row.LsList)"
              >{{ $t('table.edit') }}</el-link>

              <!-- <el-link v-if="calcPermission(permition, 2)" size="small" type="success" @click="handleDetail(scope.row.LsList)">{{ $t('table.devicedetail') }}</el-link> -->

              <el-link
                v-if="calcPermission(permition, 2)"
                class="custom-link"
                type="primary"
                @click="handleDetail(scope.row)"
              >详情</el-link>
              <el-dropdown v-if="calcPermission(permition, 4) || calcPermission(permition, 5) || calcPermission(permition, 6)">
                <el-link type="primary">
                  <i class="el-icon-more"/>
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-link v-if="calcPermission(permition, 6) && scope.row.LineState == 'On'" :underline="false" class="custom-link" @click="handleRestart(scope.row)">远程重启</el-link>
                  </el-dropdown-item>
                  <!-- <el-dropdown-item>
                    <el-link
                      v-if="calcPermission(permition, 3)"
                      :underline="false"
                      class="custom-link"
                      @click="boxLists(scope.row.LsList)"
                    >{{ $t('table.boxList') }}</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-link
                      v-if="calcPermission(permition, 4)"
                      :underline="false"
                      class="custom-link"
                      @click="bindField(scope.row.LsList)"
                    >{{ $t('table.bindField') }}</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-link
                      v-if="calcPermission(permition, 5)"
                      :underline="false"
                      class="custom-link"
                      @click="bindAgent(scope.row.LsList)"
                    >{{ $t('table.bindAgent') }}</el-link>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-link
                      v-if="calcPermission(permition, 6)"
                      :underline="false"
                      class="custom-link"
                      @click="used(scope.row.LsList)"
                    >{{ $t('table.useddetail') }}</el-link>
                  </el-dropdown-item> -->
                  <el-dropdown-item>
                    <el-link
                      v-if="calcPermission(permition, 6) && scope.row.LsList.Url"
                      :underline="false"
                      class="custom-link"
                      @click="downQRcode(scope.row.LsList)"
                    >{{ $t('table.downloadQRcode') }}</el-link>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-card class="custom-card" shadow="never">
          <el-pagination
            v-show="total>0"
            :current-page="listQuery.pageIndex"
            :page-sizes="[10,20,50,100]"
            :page-size="listQuery.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-card>
      </div>
    </transition>
    <transition name="el-zoom-in-bottom">
      <add-device
        v-if="showadd"
        :detail="detail"
        :status="status"
        @backList="backList"
        @backList1="backList1"
      />
    </transition>
    <!-- <transition name="el-zoom-in-bottom">
      <device-detail v-if="showdetail" :id="id" @backList1="backList1"/>
    </transition> -->
    <transition name="el-zoom-in-bottom">
      <box-list v-if="showbox" :id="id" :Identity="identity" @backList1="backList1"/>
    </transition>

    <!-- 批量添加弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      title="请先下载表格模板按照格式补充数据在进行上传"
    >
      <!-- <el-table :data="tableFormat" style="width: 100%">
        <el-table-column v-for="item of tableFormatHeader" :prop="item" :label="item" :key="item"/>
      </el-table>-->
      <a :href="downTemplateUrl + '/batch-add.xlsx'" target="_blank" class="down-tem">表格模板下载</a>
      <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload"/>

      <el-table
        :data="batchAddUpload.boxs"
        border
        highlight-current-row
        style="width: 100%;margin-top:20px;"
      >
        <el-table-column v-for="item of tableFormatHeader" :prop="item" :label="item" :key="item"/>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelUpload">取 消</el-button>
        <el-button type="primary" @click="batchUpload">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量添加设备 -->
    <el-dialog :visible.sync="deviceDialogVisible" :before-close="handleClose" title="批量添加设备">
      <!-- <el-table :data="tableFormat" style="width: 100%">
        <el-table-column v-for="item of tableFormatHeader" :prop="item" :label="item" :key="item"/>
      </el-table>-->
      <a :href="downTemplateUrl + '/batch-device-add.xlsx'" target="_blank" class="down-tem">表格模板下载</a>
      <upload-excel-component :on-success="addDeviceHandleSuccess" :before-upload="beforeUpload"/>

      <el-table
        :data="addDeviceTableData"
        border
        highlight-current-row
        style="width: 100%;margin-top:20px;"
      >
        <el-table-column
          v-for="item of addDeviceTableHeader"
          :prop="item"
          :label="item"
          :key="item"
        />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancelUpload">取 消</el-button>
        <el-button type="primary" @click="addDeviceBatchUpload">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 绑定场地弹窗 -->
    <el-dialog
      :visible.sync="changefield"
      :before-close="handleClose"
      title="绑定场地"
      width="30%">
      <div style="text-align: center" class="mt-20 mb-20">
        <el-select v-model="bindFieldDataForm.Id" filterable placeholder="请选择场地">

          <el-option
            v-for="item in bindFieldOptions"
            :key="item.FieldInfo.FieldId"
            :label="item.FieldInfo.FieldName"
            :value="item.FieldInfo.FieldId">
            <span style="float: left">{{ item.FieldInfo.FieldName }}</span>
            <!-- <span style="float: right; color: #8492a6; font-size: 13px" @click.stop="handleFieldEdit(item)">编辑</span> -->
          </el-option>
        </el-select>
        <!-- <el-button type="primary" icon="el-icon-plus" circle @click="handleDialog"/> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="changefield = false">取 消</el-button>
        <el-button type="primary" @click="handleFieldConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 绑定代理商弹窗 -->
    <el-dialog
      :visible.sync="changeagent"
      :before-close="handleClose"
      title="绑定代理商"
      width="30%">
      <div style="text-align: center" class="mt-20 mb-20">
        <el-select v-model="bindAgentDataForm.Id" filterable placeholder="请选择代理商1">
          <el-option
            v-for="item in bindAgentOptions"
            :key="item.UserId"
            :label="item.UserName"
            :value="item.UserId">
            <span style="float: left">{{ item.UserName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px" @click.stop="handleAgentEdit(item)">编辑</span>
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-plus" circle @click="handleDialog"/>
      </div>
      <!-- <div style="text-align: center" class="mt-20 mb-20">
        <el-select v-model="bindAgentDataForm.Id1" filterable placeholder="请选择代理商2">
          <el-option
            v-for="item in bindAgentOptions"
            :key="item.UserId"
            :label="item.UserName"
            :value="item.UserId">
            <span style="float: left">{{ item.UserName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px" @click.stop="handleAgentEdit(item)">编辑</span>
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-plus" circle @click="handleDialog"/>
      </div>
      <div style="text-align: center" class="mt-20 mb-20">
        <el-select v-model="bindAgentDataForm.Id2" filterable placeholder="请选择代理商3">
          <el-option
            v-for="item in bindAgentOptions"
            :key="item.UserId"
            :label="item.UserName"
            :value="item.UserId">
            <span style="float: left">{{ item.UserName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px" @click.stop="handleAgentEdit(item)">编辑</span>
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-plus" circle @click="handleDialog"/>
      </div>
      <div style="text-align: center" class="mt-20 mb-20">
        <el-select v-model="bindAgentDataForm.Id3" filterable placeholder="请选择代理商4">
          <el-option
            v-for="item in bindAgentOptions"
            :key="item.UserId"
            :label="item.UserName"
            :value="item.UserId">
            <span style="float: left">{{ item.UserName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px" @click.stop="handleAgentEdit(item)">编辑</span>
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-plus" circle @click="handleDialog"/>
      </div>
      <div style="text-align: center" class="mt-20 mb-20">
        <el-select v-model="bindAgentDataForm.Id4" filterable placeholder="请选择代理商5">
          <el-option
            v-for="item in bindAgentOptions"
            :key="item.UserId"
            :label="item.UserName"
            :value="item.UserId">
            <span style="float: left">{{ item.UserName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px" @click.stop="handleAgentEdit(item)">编辑</span>
          </el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-plus" circle @click="handleDialog"/>
      </div> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="changeagent = false">取 消</el-button>
        <el-button type="primary" @click="handleAgentConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加用户弹窗 -->
    <el-drawer
      ref="drawer"
      :before-close="handleClose"
      :visible.sync="dialog"
      title="添加用户"
      direction="rtl"
      custom-class="demo-drawer"
    >
      <div class="demo-drawer__content">
        <el-form ref="form" :model="form" :rules="rulesForm">
          <el-form-item label="登录账号" label-width="100px" prop="LoginNo">
            <el-input v-model="form.LoginNo" placeholder="请输入登录账号"/>
          </el-form-item>
          <el-form-item v-if="userFlag" label="密码" label-width="100px" prop="Password">
            <el-input v-model="form.Password" type="password" placeholder="请输入密码"/>
          </el-form-item>
          <el-form-item label="用户名" label-width="100px" prop="UserName">
            <el-input v-model="form.UserName" placeholder="请输入用户名"/>
          </el-form-item>
          <el-form-item label="手机号" label-width="100px" prop="TelPhone">
            <el-input v-model="form.TelPhone" placeholder="请输入手机号"/>
          </el-form-item>
          <el-form-item label="状态" label-width="100px" prop="StatusNo">
            <el-select v-model="form.StatusNo" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">取 消</el-button>
          <!-- <el-button :loading="loading" type="primary" @click="$refs.drawer.closeDrawer()">{{ '确 定' }}</el-button> -->
          <el-button type="primary" @click="handleConfirm">{{ '确 定' }}</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 下载二维码 -->
    <el-dialog :visible.sync="qrcode" title="下载二维码" width="30%">
      <div id="qrcod" ref="qrcode"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrcode = false">取 消</el-button>
        <el-button type="primary" @click="downcode">下 载</el-button>
      </span>
    </el-dialog>
    <transition name="el-zoom-in-bottom">
      <used-detail v-if="showused" :id="id" @back="backList1"/>
    </transition>
    <transition name="el-zoom-in-bottom">
      <device-detail v-if="showdetail" :detailItem="detailItem" @back="backList1"/>
    </transition>
    <el-dialog
      :visible.sync="groupVisible"
      title="设备分组"
      width="30%">
      <el-select v-model="deviceGroupDataForm.GroupId" placeholder="请选择分组名称" style="width: 100%">
        <el-option v-for="item in groupArr" :key="item.GroupId" :value="item.GroupId" :label="item.GroupName"/>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="groupCancel">取 消</el-button>
        <el-button type="primary" @click="groupConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { qryDeviceInfo, batchAddDeviceBox, binDingField, binDingAgent, batchAddDevice, updateDeviceState, reboot } from '@/api/device'
// , binDingField, qryDeviceUseDetails
import { qryRoleInfo } from '@/api/baseModule'
import { qryUser, addUser, modUser } from '@/api/user'
import { qryDeviceGroup, setDeviceGroup } from '@/api/device'
import { qryFieldInfo } from '@/api/field'
import addDevice from './addDevice'
import deviceDetail from './deviceDetail'
import boxList from './boxList'
import QrCode from 'qrcodejs2'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'// 批量添加插件
import { parseTime } from '@/utils'
import usedDetail from './usedDetail'
import md5 from 'js-md5'
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'OrderManage',
  directives: {
    waves
  },
  components: {
    addDevice,
    boxList,
    deviceDetail,
    UploadExcelComponent,
    usedDetail
  },
  data() {
    return {
      groupVisible: false,
      deviceGroupDataForm: {
        GroupId: null,
        DeviceIds: []
      },
      rulesForm: {
        LoginNo: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        TelPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 1, max: 18, message: '长度在 1 到 18 个字符', trigger: 'blur' }
        ],
        StatusNo: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      },
      form: {
        UserId: 0,
        LoginNo: null,
        TelPhone: null,
        UserName: null,
        Password: null,
        RoleId: 2,
        StatusNo: 'A'
      },
      options: [
        {
          label: '启用',
          value: 'A'
        },
        {
          label: '禁用',
          value: 'S'
        }
      ],
      dialog: false,
      identity: null,
      detail: null,
      id: null,
      listLoading: true,
      permition: null,
      showadd: false,
      showdetail: false,
      showbox: false,
      showused: false,
      changefield: false,
      changeagent: false,
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        identitys: null,
        addresss: null,
        binDingAgents: '1',
        binDingFields: '1',
        state: 'A'
      },
      list: null,
      binDingAgentss: [
        { key: '1', display_name: '全部代理商' },
        { key: '2', display_name: '绑定代理商' },
        { key: '3', display_name: '未绑定代理商' }
      ],
      binDingFieldss: [
        { key: '1', display_name: '全部场地' },
        { key: '2', display_name: '绑定场地' },
        { key: '3', display_name: '未绑定场地' }
      ],
      states: [
        {
          value: 'A',
          label: '启用'
        },
        {
          value: 'S',
          label: '禁用'
        }
      ],
      selected: null,
      fields: null,
      field: null,
      detailItem: null, // 详情传参
      subfield: [],
      agents: null,
      agent: null,
      subagent: null,
      checked: [],
      sortchange: null,
      bookType: 'xlsx',
      bookTypeList: ['xlsx', 'csv', 'txt'],
      tableKey: 0,
      total: null,
      downloadLoading: false,
      status: null,
      tableHeader: [],
      qrcode: null, // 二维码地址
      qr: null, // 二维码
      tableFormat: [{
        BoxNo: '1',
        TypeNo: 'Big或者Mid或者Small',
        LockPlate: 1,
        LockPosition: 2,
        IsMember: 'Y或者N'
      }],
      batchAddUpload: {
        devices: [],
        boxs: []
      },
      tableFormatHeader: ['BoxNo', 'LockPlate', 'LockPosition', 'TypeNo'],
      devices: [],
      downTemplateUrl: process.env.BASE_API,
      dialogVisible: false, // 判断弹窗是否出现
      deviceDialogVisible: false,
      addDeviceTableData: [],
      addDeviceTableHeader: [],
      RoleId: null,
      bindFieldDataForm: {
        Id: null,
        dIds: []
      },
      bindAgentDataForm: {
        Id: null,
        Id1: null,
        Id2: null,
        Id3: null,
        Id4: null,
        dIds: []
      },
      bindFieldOptions: [],
      bindAgentOptions: [],
      userFlag: true,
      groupArr: []
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.LsList) {
      next(vm => {
        vm.detailItem = to.query
        vm.showdetail = true
      })
    } else {
      next(vm => {
        vm.showdetail = false
        console.log(vm)
      })
    }
  },
  created() {
    console.log(this.$route.query)
    this.RoleId = this.$store.getters.roles.RoleId
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.qryList()
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            // console.log(response.LsList[0].RolePrograms)
            this.qryList()
          }
        })
      })
    }
  },
  methods: {
    handleRestart(row) { // 重启
      reboot({ identity: row.LsList.Identity }).then(res => {
        this.$message.success('下发成功')
      })
    },
    // 分组弹窗，取消
    groupCancel() {
      this.deviceGroupDataForm.GroupId = null
      this.groupVisible = false
    },
    // 分组弹窗，确定
    groupConfirm() {
      if (!this.deviceGroupDataForm.GroupId) {
        this.$message.error('请选择分组名称')
        return
      }
      console.log(this.devices)
      this.deviceGroupDataForm.DeviceIds = this.devices.map(item => {
        return item.LsList.DId
      })
      setDeviceGroup(this.deviceGroupDataForm).then(res => {
        this.$message.success('设置成功')
        this.qryList()
      })
    },
    // 分组
    opreaGroup() {
      if (!this.devices.length) {
        this.$message.error('请选择设备')
        return
      }
      this.groupVisible = true
      qryDeviceGroup({ pageIndex: 1, pageSize: 2 ** 31 - 1 }).then(res => {
        this.groupArr = res.LsList
      })
    },
    // 获取设备列表
    qryList: function() {
      qryDeviceInfo(this.listQuery).then(request => {
        this.list = request.LsList
        this.total = request.TotalRows
        this.listLoading = false
      })
    },
    // 获取用户列表
    getUserList(id) {
      qryUser({ roleId: id, pageIndex: 1, pageSize: 2147483647 }).then(res => {
        console.log(res)
        if (id === 2) { // 代理商
          this.bindAgentOptions = res.LsList
          this.bindAgentOptions.unshift({ UserName: '请选择', UserId: null })
        }
      })
    },
    handleDialog(id) {
      this.userFlag = true
      this.dialog = true
    },
    handleCommand(row, command) {
      console.dir(row)
      console.dir(command)
    },
    handleClickBind(row) {
      console.dir(row)
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.qryList()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.qryList()
    },
    sortChange(a, b) {
      return new Date(a.ExpireTime).getTime() - new Date(b.ExpireTime).getTime()
    },
    // 表格选中状态
    handleSelectionChange(e) {
      console.log(e)
      if (e.length > 0) {
        e.forEach(item => {
          this.bindFieldDataForm.dIds.push(item.LsList.DId)
          this.bindAgentDataForm.dIds.push(item.LsList.DId)
        })
        this.selected = e
        this.devices = e
      } else {
        this.bindFieldDataForm.dIds = []
        this.bindAgentDataForm.dIds = []
        this.selected = []
        this.devices = []
      }
    },
    // 添加/编辑
    adddevice(detail) {
      if (detail) {
        this.status = false
        this.detail = detail
      } else {
        this.status = true
        this.detail = { Name: null, Identity: null, FieldId: null, Address: null, Longitude: null, Latitude: null, IsDepositTel: 'N', IsFree: 'N', IsOpenHide: 0, HideProportion: null, StartHideCount: 0, MaxHideCount: 0, TypeNo: 'Small', DevVersion: 0, DevGroupId: null }
      }
      this.showadd = true
    },
    backList() {
      this.showadd = false
      this.listQuery.pageIndex = 1
      this.listLoading = true
      this.qryList()
    },
    backList1() {
      this.showdetail = false
      this.showadd = false
      this.showList = false
      this.showbox = false
      this.showused = false
      this.qryList()
    },
    // 详情
    handleDetail(e) {
      this.detailItem = e
      this.showdetail = true
    },
    // 箱子列表
    boxLists(e) {
      this.id = e.DId
      this.identity = e.Identity
      this.showbox = true
    },
    // 导出
    handleDownload() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['设备标识号', '设备名称', '地址', '会员柜子数量', '在线状态', '使用次数', '总收入', '最后连接时间']
        const filterVal = ['Identity', 'Name', 'Address', 'MemberCount', 'LineState', 'UseTotalCount', 'TotalIncome', 'LastLinkTime']
        const list = this.list
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'table-list',
          autoWidth: true,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        console.log(v)
        console.log(j)
        if (j === 'timestamp') {
          return parseTime(v['LsList'][j])
        } else {
          return v['LsList'][j]
        }
      }))
    },
    // 打开二维码下载界面
    downQRcode(detail) {
      this.qrcode = true
      this.detail = detail
      var Url = detail.Url
      this.$nextTick(() => {
        if (!this.qr) {
          this.qr = new QrCode('qrcod', {
            text: Url,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QrCode.CorrectLevel.H
          })
        } else {
          this.qr.makeCode(Url)
        }
      })
    },
    downcode(done) {
      // done()
      // console.log(done)
      var canvas = document.querySelector('#qrcod canvas')
      var url = canvas.toDataURL('image/jpeg')
      var a = document.createElement('a')
      var name = this.detail.Name
      document.getElementById('qrcod').appendChild(a)
      document.querySelector('#qrcod a').setAttribute('href', url)
      document.querySelector('#qrcod a').setAttribute('download', name + '.jpg')
      document.querySelector('#qrcod a').click()
    },
    // 搜索
    search() {
      console.log(this.listQuery)
      this.listQuery.identity = (this.listQuery.identitys && this.listQuery.identitys.length !== 0) ? this.listQuery.identitys : null
      this.listQuery.address = (this.listQuery.addresss && this.listQuery.addresss.length !== 0) ? this.listQuery.addresss : null
      console.log(this.listQuery.binDingAgents + ' ' + this.listQuery.binDingFields)
      if (this.listQuery.binDingAgents === '2') { // 绑定代理商
        this.listQuery.binDingAgent = true
        this.listQuery.notBinDingAgent = false
      } else if (this.listQuery.binDingAgents === '3') { // 未绑定代理商
        this.listQuery.binDingAgent = false
        this.listQuery.notBinDingAgent = true
      } else { // 全部
        this.listQuery.binDingAgent = false
        this.listQuery.notBinDingAgent = false
      }
      if (this.listQuery.binDingFields === '2') { // 绑定场地
        this.listQuery.binDingField = true
        this.listQuery.notBinDingField = false
      } else if (this.listQuery.binDingFields === '3') { // 未绑定场地
        this.listQuery.binDingField = false
        this.listQuery.notBinDingField = true
      } else { // 全部
        this.listQuery.binDingField = false
        this.listQuery.notBinDingField = false
      }
      this.listLoading = true
      this.listQuery.pageIndex = 1
      this.qryList()
    },
    handleFilter() {
    },
    handleCreate() {
    },
    handleClose(done) {
      this.batchAddUpload.boxs = []
      this.tableHeader = []
      this.addDeviceTableData = []
      this.addDeviceTableHeader = []
      done()
    },
    // 清空之前上传的表格
    handleCancelUpload() {
      this.batchAddUpload.boxs = []
      this.tableHeader = []
      this.addDeviceTableData = []
      this.addDeviceTableHeader = []
      this.dialogVisible = false
      this.deviceDialogVisible = false
    },
    // 批量添加设备
    handleBatchAddDevice() {
      this.deviceDialogVisible = true
    },
    // 批量添加箱子
    headShowBindDevices() {
      if (this.devices.length !== 0) {
        this.dialogVisible = true
      } else {
        this.$message.error('请先选择设备')
      }
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1
      if (isLt1M) {
        return true
      }
      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },
    // 批量上传成功
    handleSuccess({ results, header }) {
      // console.log(results)
      // console.log('614', header)
      results.forEach(item => {
        item['IsMember'] = 'N'
        for (const key in item) {
          if (key === 'LockPlate' || key === 'LockPosition' || key === 'BoxNo') {
            item[key] = parseInt(item[key])
          }
        }
      })
      results.splice(0, 1)
      this.batchAddUpload.boxs = results
      this.tableHeader = header
      // console.log(this.batchAddUpload.boxs)
      // console.log(results)
    },
    // 批量添加设备上传成功
    addDeviceHandleSuccess({ results, header }) {
      this.addDeviceTableData = results
      this.addDeviceTableHeader = header
      // console.log('665', header)
      // console.log('666', this.addDeviceTableData, this.addDeviceTableHeader)
    },
    // 确认批量上传
    batchUpload() {
      const devicesData = []
      let flage = false
      this.devices.forEach(item => {
        devicesData.push(item.LsList.DId)
        this.batchAddUpload.devices = devicesData
      })
      console.log(this.batchAddUpload.devices)
      if (devicesData.length > 0) {
        this.tableFormat.forEach(item => {
          console.log(item, 865)
          this.batchAddUpload.boxs.forEach(item1 => {
            console.log(item1, 867)
            for (const key in item) {
              // console.log(item1.hasOwnProperty(key))
              if (item1.hasOwnProperty(key)) {
                if (item1['TypeNo'] === 'Big' || item1['TypeNo'] === 'Mid' || item1['TypeNo'] === 'Small' || item1['TypeNo'] === 'SuperBig') {
                  flage = true
                } else {
                  this.$message.error('请查看TypeNo是否填写正确')
                  flage = false
                  break
                }
                flage = true
              } else {
                this.$message.error('请查看' + key + '是否填写正确')
                flage = false
                break
              }
            }
          })
        })
      }
      console.log(this.batchAddUpload)
      if (flage) {
        batchAddDeviceBox(this.batchAddUpload).then(response => {
          console.log(response)
          if (response) {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.dialogVisible = false
          } else {
            this.$message.error('数据返回错误')
          }
        })
      }
      // console.log(JSON.stringify(this.batchAddUpload))
    },
    // 确定批量上传接口
    addDeviceBatchUpload() {
      const arr = []
      console.log(this.addDeviceTableData)
      this.addDeviceTableData.forEach(item => {
        const obj = {}
        obj.identitys = item['设备编号'].trim()
        obj.DoorCount = item['一拖几'].trim()
        obj.CabinetCount = item['柜门数'].trim()
        arr.push(obj)
      })
      console.log(arr)
      batchAddDevice(arr).then(response => {
        if (response) {
          this.$message({
            showClose: true,
            message: '添加成功',
            type: 'success'
          })
          this.qryList()
          this.deviceDialogVisible = false
        }
      })
    },
    // 弹窗确定提交
    handleConfirm() {
      console.log(this.form)
      this.form.Password = this.userFlag ? md5(this.form.Password) : this.form.Password
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.UserId) { // 修改
            modUser(this.form).then(res => {
              console.log(res)
              if (res) {
                this.$message.success('修改成功')
                this.resetForm()
                this.getUserList(2)
                this.dialog = false
              }
            })
          } else {
            addUser(this.form).then(res => {
              console.log(res)
              if (res) {
                this.$message.success('添加成功')
                this.resetForm()
                this.getUserList(2)
                this.dialog = false
              }
            })
          }
        }
      })
    },
    // 绑定代理商
    bindAgent() {
      if (this.bindAgentDataForm.dIds.length <= 0) {
        this.$message.error('请选择设备')
        return
      }
      this.getUserList(2)
      this.changeagent = true
    },
    // 编辑代理商
    handleAgentEdit(item) {
      this.userFlag = false
      for (const key in this.form) {
        this.form[key] = item[key]
      }
      this.dialog = true
      console.log(this.form)
    },
    // 编辑场地方
    handleFieldEdit(item) {
      this.userFlag = false
      for (const key in this.form) {
        this.form[key] = item[key]
      }
      this.dialog = true
      console.log(this.form)
    },
    // 绑定场地确定
    handleFieldConfirm() {
      binDingField(this.bindFieldDataForm).then(res => {
        if (res) {
          this.$message.success('绑定场地成功')
          this.qryList()
          this.changefield = false
        }
      })
    },
    // 绑定代理商确定
    handleAgentConfirm() {
      binDingAgent(this.bindAgentDataForm).then(res => {
        if (res) {
          this.$message.success('绑定代理商成功')
          this.qryList()
          this.changeagent = false
        }
      })
    },
    cancelagent() {
      this.changeagent = false
    },
    cancelForm() {
      this.dialog = false
    },
    // 启用
    handleEnabled(row) {
      console.log(row)
      this.setState(row.LsList.DId, 'A')
    },
    // 禁用
    handleDis(row) {
      console.log(row)
      this.setState(row.LsList.DId, 'S')
    },
    // 设置用户状态
    setState(did, state) {
      updateDeviceState({
        did: did,
        state: state
      }).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '设置状态成功'
          })
          this.qryList()
        }
      })
    },
    submitagent() {
      // binDingAgent
      if (this.agent) {
        binDingAgent({ id: this.agent, dIds: this.subagent }).then(request => {
          if (request > 0) {
            this.qryList()
            this.$message.success('绑定成功')
          }
        })
        this.changeagent = false
      } else {
        this.$message.error('请选择代理商')
      }
      this.agent = null
    },
    // 绑定场地
    bindField() {
      if (this.bindFieldDataForm.dIds.length <= 0) {
        this.$message.error('请选择设备')
        return
      }
      qryFieldInfo({ pageIndex: 1, pageSize: 2147483647, state: 'A' }).then(res => {
        this.bindFieldOptions = res.LsList
      })
      console.log(this.bindFieldOptions)
      this.changefield = true
    },
    cancelfield() {
      this.changefield = false
    },
    submitfield() {
      if (this.field) {
        binDingField({ id: this.field, dIds: this.subfield }).then(request => {
          if (request > 0) {
            this.qryList()
            this.$message.success('绑定成功')
          }
        })
        this.changefield = false
      } else {
        this.$message.error('请选择场地')
      }
      this.field = null
    },
    resetForm() {
      this.form = {
        UserId: 0,
        LoginNo: null,
        TelPhone: null,
        UserName: null,
        Password: null,
        RoleId: 0,
        StatusNo: 'A'
      }
    },
    // 设备使用记录
    used(e) {
      this.id = e.DId
      this.showused = true
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep{
  .el-form-item__label {
    float: left !important;
  }
}

.shdow {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: rgba(55, 55, 55, 0.3);
}
.mid {
  width: 1000px;
  height: 400px;
  background: white;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 999;
}
.filter-item1 {
  width: 500px;
  margin: 90px auto 90px;
  display: block;
}
.filter-item2 {
  width: 150px;
  margin: 0 50px;
}
#qrcod img {
  margin: auto;
}
.down-tem {
  width: 100%;
  text-align: center;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  border: solid 1px #f0f0f0;
  margin-bottom: 20px;
  color: #fff;
  background-color: #409eff;
}
.demo-drawer__footer{
  text-align: center;
}
</style>
